import {toQueryString} from '@s-ui/js/lib/string'

import {FormValueObjectsFactory} from '../ValueObjects/factory.js'
import {AdComplaintConfigFormValueObjectMapper} from './AdComplaintConfigFormValueObjectMapper.js'
import {FromCaptchaStatusResponseToCaptchaFormValueObjectMapper} from './FromCaptchaStatusResponseToCaptchaFormValueObjectMapper.js'
import {FromDraftEntityToDraftFormValueObject} from './FromDraftEntityToDraftFormValueObject.js'
import {FromFormParamsToSearchUrlFormValueObjectMapper} from './FromFormParamsToSearchUrlFormValueObjectMapper.js'
import {FromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper} from './FromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper.js'
import {FromSpecsFormListToSpecsDatalistValueObjectMapper} from './FromSpecsFormListToSpecsDatalistValueObjectMapper.js'
import {GetConfigFieldsFormMapper} from './GetConfigFieldsFormMapper.js'
import {SellVehicleConfigFormValueObjectMapper} from './SellVehicleConfigFormValueObjectMapper.js'

export class FormMappersFactory {
  static adComplaintConfigFormValueObjectMapper = ({config}) =>
    new AdComplaintConfigFormValueObjectMapper({
      config,
      configFormVOFactory: FormValueObjectsFactory.configFormValueObject,
      getConfigFieldsFormMapper: FormMappersFactory.getConfigFieldsFormMapper({
        config
      })
    })

  static sellVehicleConfigFormValueObjectMapper = ({config}) =>
    new SellVehicleConfigFormValueObjectMapper({
      config,
      configFormVOFactory: FormValueObjectsFactory.configFormValueObject,
      getConfigFieldsFormMapper: FormMappersFactory.getConfigFieldsFormMapper({
        config
      })
    })

  /**
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {FromDraftEntityToDraftFormValueObject}
   */
  static fromDraftEntityToDraftFormValueObject = ({config}) =>
    new FromDraftEntityToDraftFormValueObject({
      config,
      draftFormVO: FormValueObjectsFactory.draftFormValueObject
    })

  static fromFormParamsToSearchUrlFormValueObjectMapper = () =>
    new FromFormParamsToSearchUrlFormValueObjectMapper({
      toQueryString,
      searchUrlFormValueObjectFactory: FormValueObjectsFactory.searchUrlFormValueObject
    })

  static fromCaptchaStatusResponseToCaptchaFormValueObjectMapper = () =>
    new FromCaptchaStatusResponseToCaptchaFormValueObjectMapper({
      captchaStatusFormValueObjectFactory: FormValueObjectsFactory.captchaStatusFormValueObject
    })

  static fromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper = () =>
    new FromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper({
      modelDetailFormConfigValueObjectFactory: FormValueObjectsFactory.modelDetailFormConfigValueObject
    })

  static fromSpecsFormListToSpecsDatalistValueObjectMapper = () =>
    new FromSpecsFormListToSpecsDatalistValueObjectMapper({
      datalistFormVOFactory: FormValueObjectsFactory.datalistFormValueObject,
      datalistItemFormVOFactory: FormValueObjectsFactory.datalistItemFormValueObject
    })

  static getConfigFieldsFormMapper = ({config}) =>
    new GetConfigFieldsFormMapper({
      config,
      configFieldFormVOFactory: FormValueObjectsFactory.configFieldFormValueObject
    })
}
